import _ from 'lodash';
import { array } from 'prop-types';
const initState = {
    instructor: {},
    classes: [],
    onDemands: [],
    offerings: [],
    reviews: [],
    loadingCount: 0,
    isLoading: true,
    isLoadingClasses: true,
    stripeAccount: null,
    bookmarks: [],
    bookmarksMap: {} //classId: bookmark
}

export const SET_WIDGET_CLASS_DATA = "SET_WIDGET_CLASS_DATA"
export const SET_WIDGET_STRIPE_ACCOUNT = "SET_WIDGET_STRIPE_ACCOUNT"
export const SET_WIDGET_INSTRUCTOR_DATA = "SET_WIDGET_INSTRUCTOR_DATA"
export const SET_WIDGET_LOADING = "SET_WIDGET_LOADING"
export const INCREMENT_LOADING_COUNT = "WIDGET_INCREMENT_LOADING_COUNT"
export const DECREMENT_LOADING_COUNT = "WIDGET_DECREMENT_LOADING_COUNT"
export const SET_WIDGET_OFFERINGS = "SET_WIDGET_OFFERINGS"
export const SET_WIDGET_ONDEMAND_DATA = "SET_WIDGET_ONDEMAND_DATA"

export const SET_WIDGET_BOOKMARKS = "SET_WIDGET_BOOKMARKS"
export const ADD_WIDGET_BOOKMARK = "ADD_WIDGET_BOOKMARK"
export const DELETE_WIDGET_BOOKMARK = "DELETE_WIDGET_BOOKMARK"

const arrayUnion = (arr1, arr2, identifier) => {
    const array = [...arr1, ...arr2]
  
    return _.uniqBy(array, identifier)  
}

const widgetReducer = (state = initState, action) => {
    switch (action.type) {
        case SET_WIDGET_STRIPE_ACCOUNT:
            return {
                ...state,
                stripeAccount: action.stripeAccount
            }
        case SET_WIDGET_CLASS_DATA:
            // state.classes = action.classes;
            // return state;
            return {
                ...state,
                isLoadingClasses: false,
                // classes: action.classes
                classes: arrayUnion(state.classes, action.classes, 'id')
            }
        case SET_WIDGET_INSTRUCTOR_DATA:
            // state.instructor = action.instructor;
            // return state;
            return {
                ...state,
                instructor: {
                    ...state.instructor,
                    ...action.instructor
                }
            }
        case SET_WIDGET_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            }
        case INCREMENT_LOADING_COUNT:
            const incrementedCount = (state.loadingCount + 1)
            const isLoading = incrementedCount > 0;
            return {
                ...state,
                loadingCount: incrementedCount,
                isLoading: isLoading
            }
        case DECREMENT_LOADING_COUNT:
            // const newCount = state.loadingCount - 1
            // const isLoading = newCount > 0;
            const decrementedCount = (state.loadingCount - 1)
            const isLoadingg = decrementedCount > 0;
            return {
                ...state,
                loadingCount: decrementedCount,
                isLoading: isLoadingg
            }
        case SET_WIDGET_OFFERINGS:
            return {
                ...state,
                offerings: action.offerings
            }
        case SET_WIDGET_ONDEMAND_DATA:
            return {
                ...state,
                // onDemands: action.classes
                onDemands: arrayUnion(state.onDemands, action.classes, 'id')
            }
        case SET_WIDGET_BOOKMARKS:

            var bookmarksMap = action.bookmarks.reduce((map, obj) => {
                if (obj.documentId) {
                    map[obj.documentId] = obj
                }
                return map
            }, {})

            return {
                ...state,
                bookmarks: action.bookmarks,
                bookmarksMap: bookmarksMap
            }
        case ADD_WIDGET_BOOKMARK:
            var {bookmarks, bookmarksMap} = state

            bookmarksMap[action?.bookmark?.documentId ?? ""] = action.bookmark
            return {
                ...state,
                bookmarks: bookmarks.concat(action.bookmark),
                bookmarksMap: bookmarksMap
            }
        case DELETE_WIDGET_BOOKMARK:
            var {bookmarksMap} = state
            const bookmarksAfterDelete = _.filter(state.bookmarks, function(x) { return x?.id !== action?.bookmark?.id; });
            // bookmarksMap[action?.bookmark?.documentId ?? ""] = false
            var bookmarksMap = bookmarksAfterDelete.reduce((map, obj) => {
                if (obj.documentId) {
                    map[obj.documentId] = obj
                }
                return map
            }, {})
            return {
                ...state,
                bookmarks: bookmarksAfterDelete,
                bookmarksMap: bookmarksMap
            }
        default:
            break;
    }

    return state
}

export default widgetReducer;